import { NotifyOnChangeProps, useQuery } from "@tanstack/react-query";
import { useDeviceKey } from "./useDeviceKey";
import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { AgendaItemDetails } from "@/models/prepareRecording";

const fetchAgendasList = async (deviceKey: string) => {

  const initialToken = recoverTokenInfo();

  const response = await api.get<AgendaItemDetails[]>(`/${API_VERSIONS.v0}/agenda`, {
    headers: {
      Authorization: `Bearer ${initialToken}`,
      "X-iBabs-Device-Id": deviceKey,
    },
  });

  return response.data;
};

export function useAgendasList(props?: { notifyOnChangeProps?: NotifyOnChangeProps }) {
  const deviceKey = useDeviceKey();

  return useQuery({
    queryKey: ["agendasList"],
    queryFn: () => fetchAgendasList(deviceKey),
    staleTime: 1000 * 5, // milliseconds
    ...props
  });
}
